module.exports = __webpack_public_path__ + "static/00001.ff149f53.jpg";